// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-22c552be] {\n  padding: 0.42667rem;\n}\n.container .title[data-v-22c552be] {\n  font-size: 0.53333rem;\n  color: rgba(0, 0, 0, 0.85);\n  margin-bottom: 0.61333rem;\n}\n.container .date[data-v-22c552be] {\n  font-size: 0.42667rem;\n  color: rgba(0, 0, 0, 0.85);\n}\n.container .content[data-v-22c552be] {\n  margin-top: 1.14667rem;\n  font-size: 0.37333rem;\n  color: rgba(0, 0, 0, 0.85);\n  line-height: 1.5;\n  text-align: justify;\n  word-break: break-all;\n}\n", ""]);
// Exports
module.exports = exports;
